exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".warmupQuestionDisplayPage .warmupBox{display:inline-block;width:48%;margin-right:2%;margin-bottom:15px;border:1px solid #ddd;border-radius:5px;padding:5px;vertical-align:top}.warmupQuestionDisplayPage .warmupHeader{text-align:center;border-bottom:1px solid #ddd}.warmupQuestionDisplayPage .warmupData{font-size:12px;height:150px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/appdev/warmup_question_display_page.scss
// module id = 817
// module chunks = 0